

const Heade =(props)=>{
    return(
        
        <div>
            <h5 className="text-light">{props.head} {props.head1}</h5>
        </div>
        
    );
}

export default Heade;